import request from '@/utils/request'

export function getTravellers(query, pagination) {
  return request({
    url: '/config-service/v1/traveller/list',
    method: 'get',
    params: {
      ...query,
      ...pagination
    }
  })
}

export function storeTraveller(id, data) {
  return request({
    url: `/config-service/v1/traveller/insert/${id}`,
    method: 'post',
    data: data
  })
}

export function updateTraveller(id, data) {
  return request({
    url: `/config-service/v1/traveller/update/${id}`,
    method: 'put',
    data: data
  })
}

export function getTraveller(id) {
  return request({
    url: `/config-service/v1/traveller/${id}`,
    method: 'get'
  })
}

export function getNations() {
  return request({
    url: '/config-service/v1/traveller/list'
  })
}
